import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { StoreAssetV2FragmentFragmentDoc } from '../fragments/storeAssetV2.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoreAssetsV2QueryVariables = Types.Exact<{
  filter: Types.StoreAssetFilterV2;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type StoreAssetsV2Query = { __typename?: 'Query', storeAssetsV2: { __typename?: 'StoreAssetsResult', total: number, items: Array<{ __typename?: 'StoreAssetV2', id: string, creation_timestamp?: string | null, removed_at?: string | null, name: string, description?: string | null, internal_comment?: string | null, epc_tag: string, price?: number | null, is_billable?: boolean | null, is_recalled?: boolean | null, billing_start?: string | null, billing_end?: string | null, billing_frequency?: Types.BillingFrequency | null, billing_start_with_onboarding?: boolean | null, custom_fields: Array<{ __typename?: 'CustomFieldValue', id: string, name: string, type: Types.CustomFieldType, value?: string | null }>, item_type: { __typename?: 'ItemType', id: number, name: string, price?: number | null, category: Types.ItemTypeCategory, image_url?: string | null, color_hex_code?: string | null, custom_field_definitions?: Array<{ __typename?: 'CustomFieldDefinition', id: string, name: string, type: Types.CustomFieldType, required?: boolean | null, default_value?: string | null, depends_on?: { __typename?: 'CustomFieldDependency', field_id: string, value: string } | null }> | null } }> } };


export const StoreAssetsV2Document = gql`
    query StoreAssetsV2($filter: StoreAssetFilterV2!, $skip: Int, $take: Int) {
  storeAssetsV2(filter: $filter, skip: $skip, take: $take) {
    total
    items {
      ...StoreAssetV2Fragment
    }
  }
}
    ${StoreAssetV2FragmentFragmentDoc}`;

/**
 * __useStoreAssetsV2Query__
 *
 * To run a query within a React component, call `useStoreAssetsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useStoreAssetsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreAssetsV2Query({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useStoreAssetsV2Query(baseOptions: Apollo.QueryHookOptions<StoreAssetsV2Query, StoreAssetsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreAssetsV2Query, StoreAssetsV2QueryVariables>(StoreAssetsV2Document, options);
      }
export function useStoreAssetsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreAssetsV2Query, StoreAssetsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreAssetsV2Query, StoreAssetsV2QueryVariables>(StoreAssetsV2Document, options);
        }
export type StoreAssetsV2QueryHookResult = ReturnType<typeof useStoreAssetsV2Query>;
export type StoreAssetsV2LazyQueryHookResult = ReturnType<typeof useStoreAssetsV2LazyQuery>;
export type StoreAssetsV2QueryResult = Apollo.QueryResult<StoreAssetsV2Query, StoreAssetsV2QueryVariables>;